import { render, staticRenderFns } from "./NoTableData.ts.vue?vue&type=template&id=39cbad45"
import script from "./NoTableData.ts.vue?vue&type=script&lang=ts"
export * from "./NoTableData.ts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports